<template>
    <div class="accountRecharge">
        <div class="topBack">
            <el-page-header @back="goBack" content="账户">
            </el-page-header>
        </div>
        <div class="accountRechargeMain">
            <div class="addStu">
                <el-form :inline="true" :model="formSearch" class="demo-form-inline" size="mini" @submit.native.prevent>
                    <el-form-item label="">
                        <div style="overflow: hidden;">
                            <div class="fl">
                                <el-select v-model="formSearch.region" placeholder="" @change="changeType"
                                    style="width: 120px;">
                                    <el-option label="按账户查找" value="1"></el-option>
                                    <el-option label="按关联学员查找" value="2"></el-option>
                                </el-select>
                            </div>
                            <div class="fr" v-if="formSearch.region === '1'">
                                <el-select @change="changegAccount" v-model="formSearch.account_no" filterable remote
                                    reserve-keyword placeholder="请输入关键词" :remote-method="remoteMethod" :loading="loading">
                                    <el-option v-for="item in options1" :key="item.value" :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="fr" v-if="formSearch.region === '2'">
                                <autocomplete @getUserId="getUserId" @getUserName="getUserName"></autocomplete>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="">
                        <!-- <el-button type="primary" @click="addAccountRecharge">创建新账户</el-button> -->
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <div class="boxBorder" style="margin-top: 10px;">
                <ul class="topTxtStyle">
                    <li>
                        <span>充值账户：</span>
                        <span>{{ xmAccountData.account_no }}</span>
                    </li>
                    <li>
                        <span>总 余 额 ：</span>
                        <span>￥{{ xmAccountData.total_amount
                        }}(实充余额￥{{ xmAccountData.amount }}，赠送余额￥{{ xmAccountData.give_amount }})</span>
                    </li>
                    <li>
                        <div style="overflow: hidden;">
                            <div class="fl">关联学员：</div>
                            <div class="fl">
                                <div v-for="(item, index) in xmAccountData.xmAccountStuInfoArr" :key="index">{{
                                    item.stu_realname }}</div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <!-- <div v-else class="boxBorder">
                <el-empty description="描述文字"></el-empty>
            </div> -->

        </div>

        <div class="accountRechargeMain">
            <div>退款信息</div>
            <el-divider></el-divider>
            <div style="margin-top: 10px; padding: 10px;">
                <el-form :inline="true" :model="formInline" class="demo-form-inline" size="mini" label-width="100px">
                    <el-form-item label="实充余额退款">
                        <el-input type="Number"
                            oninput="if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
                            v-model="formInline.rechargeAmount" placeholder="请输入实充金额">
                            <span slot="prefix">￥</span>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="赠送余额扣减" style="margin-left: 50px;">
                        <el-input type="Number"
                            oninput="if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
                            v-model="formInline.give_amount" placeholder="请输入赠送金额">
                            <span slot="prefix">￥</span>
                        </el-input>
                    </el-form-item>
                    <br />
                    <el-form-item label="手续费">
                        <el-input type="Number"
                            oninput="if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
                            v-model="formInline.commission" placeholder="请输入赠送金额">
                            <span slot="prefix">￥</span>
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <div style="overflow: hidden;">
                <div class="fr">
                    <span>应退金额：￥ {{ sum.toFixed(2) }}</span>
                </div>
            </div>
        </div>
        <div class="accountRechargeMain">
            <div>支付信息</div>
            <el-divider></el-divider>
            <div>应退金额：￥{{ sum.toFixed(2) }}</div>
            <div style="margin-top: 15px;">请选择退款方式</div>

            <div style="margin-top: 10px; padding: 10px;">
                <ul style="overflow: hidden;">
                    <li @click="changepaymentType(item, index)"
                        :class="currentIndex === index ? 'activeBorder' : 'borderBox'" class="fl"
                        v-for="(item, index) in paymentType" :key="index">
                        <div>{{ item.name }}</div>
                    </li>
                </ul>
            </div>
            <!-- 支付宝凭证 -->
            <div>
                <div style="margin-top: 18px;">
                    <span v-if="currentIndex === 0">支付宝凭证</span>
                    <span v-if="currentIndex === 1">微信凭证</span>
                    <span v-if="currentIndex === 2">现金凭证</span>
                    <span v-if="currentIndex === 3">网银转账</span>
                    <span v-if="currentIndex === 4">Pos机刷卡</span>
                </div>
                <div style="margin-top: 18px;">
                    <el-upload action="" :http-request="uploadFileSchool" :on-remove="handleRemove1"
                        :on-change="handleChangeFile1" :auto-upload="false" :limit="3" :file-list="zfbimgList"
                        list-type="picture">
                        <el-button size="mini" type="primary" plain>点击上传<i class="el-icon-upload el-icon--right"></i>
                        </el-button>
                        <span slot="tip" class="el-upload__tip">
                            只能上传jpg/png文件
                        </span>
                    </el-upload>
                </div>
            </div>
            <el-divider></el-divider>
        </div>
        <!-- 其他信息 -->
        <div class="accountRechargeMain" style="margin-top: 10px;">
            <div>其他信息</div>
            <el-divider></el-divider>
            <el-form :inline="true" :model="formInline" class="demo-form-inline" size="mini" @submit.native.prevent>
                <el-form-item label="经办日期">
                    <el-date-picker v-model="formInline.deal_date" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" placement="bottom-start">
                    </el-date-picker>
                </el-form-item>

                <br />
                <el-form-item label="对内备注">
                    <el-upload action="" :http-request="uploadFileSchool" :on-remove="handleRemove"
                        :on-change="handleChangeFile" :auto-upload="false" :limit="3" :file-list="imgList"
                        list-type="picture">
                        <el-button size="mini" type="primary" plain>点击上传<i class="el-icon-upload el-icon--right"></i>
                        </el-button>
                        <div slot="tip" class="el-upload__tip">
                            只能上传jpg/png文件，且不超过500kb
                        </div>
                    </el-upload>
                    <el-input style="width: 500px;" type="textarea" :autosize="{ minRows: 5 }" placeholder="请输入内容"
                        v-model="formInline.in_remark">
                    </el-input>
                </el-form-item>
                <br />
                <el-form-item label="对外备注">
                    <el-input style="width: 500px;" type="textarea" :autosize="{ minRows: 5 }" placeholder="请输入内容"
                        v-model="formInline.out_remark">
                    </el-input>
                </el-form-item>

            </el-form>

        </div>
        <div class="accountRechargeMain" style="margin-top: 10px;">
            <div style="overflow: hidden;">
                <div class="fr"> <el-button type="primary" size="small" @click="submit">确认退款</el-button></div>
            </div>
        </div>
        <!-- 选择学员 -->
        <el-dialog title="选择学员" :visible.sync="dialogVisible1" width="80%" top="5vh">
            <el-form :inline="true" size="mini" label-width="500" @submit.native.prevent>
                <el-form-item label="">
                    <el-input v-model="formInline.user" placeholder="请输入学员姓名" style="width:250px;"
                        @keyup.enter.native="search"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
            </el-form>
            <div style="overflow: hidden;">
                <div class="fl" style="width: 60%;">
                    <div class="table-style">
                        <el-table ref="tableDataList" :row-key="(row) => { return row.id }" size="mini" height="30vh"
                            :data="tabledataStu" stripe :header-cell-style="{ background: '#f5f7fa', color: '#909399' }"
                            highlight-current-row @selection-change="handleSelectionChange">
                            <el-table-column type="selection" width="55" :reserve-selection="true">
                            </el-table-column>
                            <el-table-column width="50" label="序号">
                                <template slot-scope="scope">
                                    <span>{{
                                        scope.$index + 1 + (page_noStu - 1) * page_sizeStu
                                    }}</span>
                                </template>
                            </el-table-column>

                            <el-table-column label="学员姓名">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.studentUserInfo.realname }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="normal_state" label="学员状态">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.normal_state == '1'">试听</span>
                                    <span v-else-if="scope.row.normal_state == '2'">在读</span>
                                    <span v-else-if="scope.row.normal_state == '3'">休学</span>
                                    <span v-else-if="scope.row.normal_state == '4'">已退学</span>
                                    <span v-else>未知</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="sex" label="性别">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.studentUserInfo.sex }}</span>
                                </template>
                            </el-table-column>

                            <el-table-column prop="name" label="平台账号"></el-table-column>
                            <el-table-column align="left" label="所在班级" :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.class_str }}</span>
                                </template>
                            </el-table-column>

                            <el-table-column label="有效期">
                                <template slot-scope="scope">
                                    <span>
                                        <span v-if="scope.row.enddate">
                                            {{ scope.row.enddate.slice(0, 10) }}
                                        </span>
                                        <span style="color: #e6a23c" v-else>请设置有效期</span>
                                    </span>
                                </template>
                            </el-table-column>

                        </el-table>
                    </div>
                    <div style="margin-top: 30px; text-align: right">
                        <el-pagination @current-change="handleCurrentChange" :current-page="page_noStu"
                            :page-size="page_sizeStu" layout="total,prev, pager, next" :total="totalStu"></el-pagination>
                    </div>
                </div>
                <div class="fr" style="width: 39%;overflow-y: auto;">
                    <el-table :header-cell-style="{ background: '#f5f7fa', color: '#909399' }" :data="multipleSelection"
                        stripe style="width: 100%" size="mini" height="30vh">
                        <el-table-column prop="" label="姓名">
                            <template slot-scope="scope">
                                <span>{{ scope.row.studentUserInfo.realname }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="name" label="账号">
                        </el-table-column>
                        <el-table-column prop="" label="操作">
                            <template slot-scope="scope">
                                <el-button type="text" @click="deleteRow(scope.row)">移除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="Cancel_ChooseStudent">取消</el-button>
                <el-button size="small" type="primary" @click="Submit_ChooseStudent">确定</el-button>
            </span>
        </el-dialog>
        <!-- 选择学员1 -->
        <el-dialog title="学员有多个充值账户" :visible.sync="dialogVisible3" width="40%" top="7vh">
            <div>学员已关联多个充值账户，请选择本次要充值的账户。</div>
            <el-radio-group v-model="radio" style="margin-top: 20px;">
                <el-radio style="display: block;margin-bottom: 20px;" v-for="item in xmAccountList1" :key="item.id"
                    :value="item.id" :label="item.account_no">
                    {{ item.account_no }}
                </el-radio>
            </el-radio-group>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="dialogVisible3 = false">取消</el-button>
                <el-button size="small" type="primary" @click="submitStuMsg">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import {
    getFormalStudentList,
    getXmAccountInfoByAccountNo,
    getXmAccountInfoByStuId,
    addAccountRefundOrder

} from "@/api/educational";
import uploadFileSchool from "@/config/uploadFileSchool";
import autocomplete from "@/components/autocomplete";
import moment from "moment";

export default {
    components: {
        autocomplete
    },
    data() {
        return {
            xmAccountList1: [],
            radio: '',
            dialogVisible3: false,
            loading: false,
            options1: [],
            accountList: [],
            accountList1: [],
            xmAccountData: {
                account_no: ''
            },
            formSearch: {
                region: '1'
            },
            zhimgList: [],
            posimgList: [],
            wyimgList: [],
            xjimgList: [],
            wximgList: [],
            zfbimgList: [],
            currentIndex: 0,
            imgList: [],
            //支付方式
            paymentType: [
                {
                    id: '1',
                    name: '支付宝',
                    isCheck: true,
                    amountOfMoney: 0,
                    disabled: false,
                },
                {
                    id: '2',
                    name: '微信',
                    isCheck: false,
                    amountOfMoney: 0,
                    disabled: false,
                }, {
                    id: '3',
                    name: '现金',
                    isCheck: false,
                    amountOfMoney: 0,
                    disabled: false,
                }, {
                    id: '4',
                    name: '网银转账',
                    isCheck: false,
                    amountOfMoney: 0,
                    disabled: false,
                }, {
                    id: '5',
                    name: 'POS机刷卡',
                    isCheck: false,
                    amountOfMoney: 0,
                    disabled: false,
                }
            ],
            //创建搜索学员
            formInline: {
                give_amount: 0,
                rechargeAmount: 0,
                commission: 0,
                deal_date: ''
            },
            page_noStu: 1,
            page_sizeStu: 10,
            totalStu: 0,
            tabledataStu: [],
            chooseStudent: {},
            dialogVisible1: false,
            multipleSelection: [],
            stuId: '',
            stuName: '',
            pay_type: '1'
        };
    },
    computed: {
        sum() {
            const rechargeAmount = this.formInline.rechargeAmount || 0;
            const commission = this.formInline.commission || 0;
            return parseFloat(rechargeAmount) - parseFloat(commission)
        },
    },
    mounted() {
        this.formInline.deal_date = moment().format("YYYY-MM-DD")
        // getXmAccountInfoByAccountNo({
        //     account_no: query,
        //     campusIdArr: JSON.stringify(this.$store.state.user.selected_schools),
        // }).then((res) => {
        //     console.log(res, 112545);
        //     this.accountList1 = res.xmAccountList
        //     this.accountList = res.xmAccountList.map(item => {
        //         return { value: `${item.id}`, label: `${item.account_no}` };
        //     });
        //     this.loading = false;
        //     this.options1 = this.accountList.filter(item => {
        //         return item.label.toLowerCase()
        //             .indexOf(query.toLowerCase()) > -1;
        //     });
        // })
        if (this.$route.query.account_no != undefined) {
            getXmAccountInfoByAccountNo({
                account_no: this.$route.query.account_no,
                campusIdArr: JSON.stringify(this.$store.state.user.selected_schools),
            }).then((res) => {
                console.log(res, 112545);
                res.xmAccountList.map((item) => {
                    this.account_no1 = item.account_no
                    this.educational_institution_campus_id = item.educational_institution_campus_id
                })
                this.accountList1 = res.xmAccountList
                this.accountList1.map((item) => {
                    console.log(item.id, 451212);
                    console.log(item, 451212);
                    this.xmAccountData = item
                })
            })

        }

    },
    methods: {
        handleInput(e) {
            // 通过正则过滤小数点后两位
            e.target.value = (e.target.value.match(/^\d*(\.?\d{0,1})/g)[0]) || null
        },
        handleInput1(e) {
            // 通过正则过滤小数点后两位
            e.target.value = (e.target.value.match(/^\d*(\.?\d{0,1})/g)[0]) || null
        },
        handleInput2(e) {
            // 通过正则过滤小数点后两位
            e.target.value = (e.target.value.match(/^\d*(\.?\d{0,1})/g)[0]) || null
        },
        submit() {
            let proof_img = ''
            if (this.zfbimgList != 0) {
                this.zfbimgList.map((item) => {
                    proof_img = item.url
                })
            }
            console.log(proof_img);
            console.log(this.zfbimgList, 1111);
            let in_remark_img = []
            if (this.imgList.length != 0) {
                this.imgList.map((item) => {
                    in_remark_img.push({
                        url: item.url
                    })
                })
            }
            if (this.formInline.rechargeAmount > this.xmAccountData.amount) {
                this.$message.warning('退款金额不能大于实充余额')
                return false
            }
            if (this.formInline.give_amount > this.xmAccountData.give_amount) {
                this.$message.warning('退款金额不能大于赠送余额')
                return false
            }
            addAccountRefundOrder({
                xm_account_id: this.xmAccountData.id,
                deal_date: this.formInline.deal_date,
                in_remark: this.formInline.in_remark,
                in_remark_img: JSON.stringify(in_remark_img),
                out_remark: this.formInline.out_remark,
                total_amount: this.sum,
                pay_type: this.pay_type,
                amount: this.formInline.rechargeAmount,
                give_amount: this.formInline.give_amount,
                service_amount: this.formInline.commission,
                proof_img: proof_img
            }).then(() => {
                this.$message.success('账户退款成功')
                this.$router.push({
                    name: "ordermanagement",
                });
            })
        },
        changegAccount(val) {
            console.log(val, 451212);
            this.accountList1.map((item) => {
                console.log(item.id, 451212);
                console.log(item, 451212);
                this.xmAccountData = item
            })
        },
        remoteMethod(query) {
            console.log(query, 54512);
            if (query !== '') {
                this.loading = true;
                getXmAccountInfoByAccountNo({
                    account_no: query,
                    campusIdArr: JSON.stringify(this.$store.state.user.selected_schools),
                }).then((res) => {
                    console.log(res, 112545);
                    this.accountList1 = res.xmAccountList
                    this.accountList = res.xmAccountList.map(item => {
                        return { value: `${item.id}`, label: `${item.account_no}` };
                    });
                    this.loading = false;
                    this.options1 = this.accountList.filter(item => {
                        return item.label.toLowerCase()
                            .indexOf(query.toLowerCase()) > -1;
                    });
                })
            } else {
                this.options1 = [];
            }
        },
        getUserName(val) {
            console.log(val, 455411);
            this.stuName = val.studentUserInfo.realname
        },
        getUserId(val) {
            console.log(val, 4512);
            this.stuId = val
            if (val != '') {
                getXmAccountInfoByStuId({
                    student_user_id: this.stuId
                }).then((res) => {
                    console.log(res, 4851);
                    this.xmAccountList1 = res.xmAccountList
                    if (res.xmAccountList.length === 0) {
                        this.$message.success('学员暂无充值账户')
                        this.xmAccountData = {}
                    }
                    if (res.xmAccountList.length > 1) {
                        console.log(121212);
                        this.dialogVisible3 = true
                    }
                    if (res.xmAccountList.length === 1) {
                        this.xmAccountList1.map((item) => {
                            console.log(item, 545656);
                            this.xmAccountData = item
                        })
                    }

                })
            }
        },
        submitStuMsg(val) {
            console.log(val, 545656);
            this.xmAccountList1.map((item) => {
                console.log(item, 545656);
                if (this.radio === item.account_no) {
                    this.xmAccountData = item
                }
            })
            this.dialogVisible3 = false
        },

        changeType() {
            this.xmAccountData = {}
            this.formSearch.account_no = ''
            console.log(this.formSearch.account_no, 4545);

        },
        //上传凭证 账户充值
        handleRemove6() { },
        async handleChangeFile6(file, fileList) {
            if (!this.uploadFileTime) {
                await this.uploadFileOss6(fileList);
            }
        },
        async uploadFileOss6(list) {
            this.uploadFileTime = true;
            await uploadFileSchool(list, this.$store.state.user.userInfo.code).then(
                (res) => {
                    console.log("上传图片");
                    console.log(res);
                    this.zhimgList = res;
                    if (this.zhimgList.length != 0) {
                        this.paymentType.map((item) => {
                            if (item.id === '6') {
                                item.proof_img = []

                                this.zhimgList.map((item1) => {
                                    item.proof_img.push({
                                        url: item1.url
                                    })
                                })

                            }
                        })

                    }
                    this.uploadFileTime = false;
                }
            );
        },
        //上传凭证 pos机
        handleRemove5() { },
        async handleChangeFile5(file, fileList) {
            if (!this.uploadFileTime) {
                await this.uploadFileOss5(fileList);
            }
        },
        async uploadFileOss5(list) {
            this.uploadFileTime = true;
            await uploadFileSchool(list, this.$store.state.user.userInfo.code).then(
                (res) => {
                    console.log("上传图片");
                    console.log(res);
                    this.posimgList = res;
                    if (this.posimgList.length != 0) {
                        this.paymentType.map((item) => {
                            if (item.id === '5') {
                                item.proof_img = []

                                this.posimgList.map((item1) => {
                                    item.proof_img.push({
                                        url: item1.url
                                    })
                                })

                            }
                        })

                    }
                    this.uploadFileTime = false;
                }
            );
        },
        //上传凭证 网银
        handleRemove4() { },
        async handleChangeFile4(file, fileList) {
            if (!this.uploadFileTime) {
                await this.uploadFileOss4(fileList);
            }
        },
        async uploadFileOss4(list) {
            this.uploadFileTime = true;
            await uploadFileSchool(list, this.$store.state.user.userInfo.code).then(
                (res) => {
                    console.log("上传图片");
                    console.log(res);
                    this.wyimgList = res;
                    if (this.wyimgList.length != 0) {
                        this.paymentType.map((item) => {
                            if (item.id === '4') {
                                item.proof_img = []

                                this.wyimgList.map((item1) => {
                                    item.proof_img.push({
                                        url: item1.url
                                    })
                                })

                            }
                        })

                    }
                    this.uploadFileTime = false;
                }
            );
        },
        //上传凭证 现金
        handleRemove3() { },
        async handleChangeFile3(file, fileList) {
            if (!this.uploadFileTime) {
                await this.uploadFileOss3(fileList);
            }
        },
        async uploadFileOss3(list) {
            this.uploadFileTime = true;
            await uploadFileSchool(list, this.$store.state.user.userInfo.code).then(
                (res) => {
                    console.log("上传图片");
                    console.log(res);
                    this.xjimgList = res;
                    if (this.xjimgList.length != 0) {
                        this.paymentType.map((item) => {
                            if (item.id === '3') {
                                item.proof_img = []

                                this.xjimgList.map((item1) => {
                                    item.proof_img.push({
                                        url: item1.url
                                    })
                                })

                            }
                        })

                    }
                    this.uploadFileTime = false;
                }
            );
        },
        //上传凭证 微信
        handleRemove2() { },
        async handleChangeFile2(file, fileList) {
            if (!this.uploadFileTime) {
                await this.uploadFileOss2(fileList);
            }
        },
        async uploadFileOss2(list) {
            this.uploadFileTime = true;
            await uploadFileSchool(list, this.$store.state.user.userInfo.code).then(
                (res) => {
                    console.log("上传图片");
                    console.log(res);
                    this.wximgList = res;
                    if (this.wximgList.length != 0) {
                        this.paymentType.map((item) => {
                            if (item.id === '2') {
                                item.proof_img = []

                                this.wximgList.map((item1) => {
                                    item.proof_img.push({
                                        url: item1.url
                                    })
                                })

                            }
                        })

                    }
                    console.log(this.paymentType, 2323233);

                    this.uploadFileTime = false;
                }
            );
        },
        //上传凭证 支付宝
        handleRemove1() { },
        async handleChangeFile1(file, fileList) {
            if (!this.uploadFileTime) {
                await this.uploadFileOss1(fileList);
            }
        },
        async uploadFileOss1(list) {
            this.uploadFileTime = true;
            await uploadFileSchool(list, this.$store.state.user.userInfo.code).then(
                (res) => {
                    console.log("上传图片");
                    console.log(res, 2323233);
                    this.zfbimgList = res;
                    if (this.zfbimgList.length != 0) {
                        this.paymentType.map((item) => {
                            if (item.id === '1') {
                                item.proof_img = []
                                this.zfbimgList.map((item1) => {
                                    item.proof_img.push({
                                        url: item1.url
                                    })
                                })
                            }
                        })

                    }
                    console.log(this.paymentType, 2323233);
                    this.uploadFileTime = false;
                }
            );
        },
        changepaymentType(val, index) {
            console.log(val, 122132);
            console.log(index, 122132);
            this.currentIndex = index
            this.pay_type = val.id


        },


        //对内备注上传图片
        uploadFileSchool() { },
        handleRemove() { },
        async handleChangeFile(file, fileList) {
            if (!this.uploadFileTime) {
                await this.uploadFileOss(fileList);
            }
        },
        async uploadFileOss(list) {
            this.uploadFileTime = true;
            await uploadFileSchool(list, this.$store.state.user.userInfo.code).then(
                (res) => {
                    console.log("上传图片");
                    console.log(res);
                    this.imgList = res;
                    this.uploadFileTime = false;
                }
            );
        },
        //计算支付
        disablePaymentTypes(paymentTypes, isDisabled) {
            paymentTypes.forEach(item => {
                item.disabled = isDisabled;
            });
        },
        chengepaymentType(row) {
            console.log(row, 45123);

        },
        //创建学员
        deleteRow(row) {
            this.multipleSelection.splice(this.multipleSelection.indexOf(row), 1);
            this.$nextTick(() => {
                this.$refs.tableDataList.toggleRowSelection(row);
            })
        },
        search() {
            console.log(121212, 456362);
            this.page_noStu = 1;
            if (this.$store.state.user.selected_schools.length == 0) {
                this.$message.warning("请选择校区");
            } else if (this.$store.state.user.selected_schools.length == 1) {
                this.getFormalStudentList();
            } else {
                this.getFormalStudentList();
            }
        },
        //查询学员
        //查询在读学员
        getFormalStudentList() {
            getFormalStudentList({
                realname: this.formInline.user,
                campusIds: JSON.stringify(this.$store.state.user.selected_schools),
                page_no: this.page_noStu,
                page_size: this.page_sizeStu,
            }).then((res) => {
                console.log("查询所有在读学员");
                console.log(res);
                this.tabledataStu = res.studentList;
                this.totalStu = res.total;
            });
        },
        handleCurrentChange(val) {
            this.page_noStu = val;
            this.getFormalStudentList();
        },
        Cancel_ChooseStudent() {
            this.dialogVisible1 = false;
            console.log("取消选择学员");
        },
        Submit_ChooseStudent() {
            this.dialogVisible1 = false;
            console.log(this.chooseStudent, 146523);
        },
        addAccountRecharge() {

            this.search()

            this.dialogVisible1 = true;
            this.$nextTick(() => {
                this.$refs.tableDataList.clearSelection()
            })

        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            console.log(this.multipleSelection, 75324);
        },
        goBack() {
            this.$router.push({
                name: "ordermanagement",
            });
        }
    }
}
</script>
<style scoped>
.accountRecharge {
    padding: 10px;

}

.topBack {
    padding: 10px;
    width: 100%;
    background: #fff;
    border-radius: 5px;
}

.accountRechargeMain {
    margin-top: 10px;
    background: #fff;
    padding: 15px;
    border-radius: 5px;
}

/deep/ .addStu .el-form-item--mini.el-form-item {
    margin-bottom: 0px;
}

/deep/ .el-divider--horizontal {
    margin: 18px 0px;
}

.fl {
    float: left;
}

.fr {
    float: right;
}

.boxBorder {
    padding: 10px;
    border: 1px solid #DCDFE6;
    border-radius: 5px;
}

.topTxtStyle li {
    margin-bottom: 10px;
    font-size: 14px;
}

.borderpayment {
    width: 16%;
    margin-right: 10px;
    border: 1px solid #ccc;
    padding: 10px;
    margin-bottom: 18px;
    border-radius: 5px;
    min-height: 50px;
}

.borderBox {
    width: 120px;
    line-height: 30px;
    border: 1px solid #ccc;
    margin-right: 20px;
    text-align: center;
    border-radius: 5px;
    cursor: pointer;
}

.activeBorder {
    border: 1px solid #6BC7FF;
    width: 120px;
    line-height: 30px;
    margin-right: 20px;
    text-align: center;
    border-radius: 5px;
    cursor: pointer;
    background: #409EFF;
    color: #fff;
}
</style>